import apiService from './apiService';
import { API_ENDPOINTS } from '../constants/apiConstants';

export const authAPI = {
  login: async (credentials: { email: string; password: string }) => {
    const response = await apiService.post(API_ENDPOINTS.AUTH.LOGIN, credentials);
    return response.data;
  },
  
  logout: async () => {
    const response = await apiService.delete(API_ENDPOINTS.AUTH.LOGOUT);
    return response.data;
  },
};